import styled from "styled-components";
import { bp } from "theme";
import LinkedinLogo from "assets/svgs/LinkedinLogo";
import FacebookLogo from "assets/svgs/FacebookLogo";
import InstagramLogo from "assets/svgs/InstagramLogo";
import TwitterLogo from "assets/svgs/TwitterLogo";
import YoutubeLogo from "assets/svgs/YoutubeLogo";
import { getUrlPath } from "utils/helpers";
import ApnaTimeLogo from "assets/svgs/ApnaTimeLogo";
import clsx from "clsx";
import Link from "next/link";
import { createBranchDeepLink } from "libs/BranchIO";
import { BRANCH_APP_DOWNLOAD_CAMPAIGNS } from "utils/constants";
import getTrackingParams from "utils/getTrackingParams";
import { isHostLaunchedMicrosite } from "utils";
import ApnaViLogo from "assets/svgs/ApnaViLogo";
import CustomImage from "../Image";

type SocialContainerWrapperProps = {
	background: string;
};

const FooterSocialContainer = ({
	source,
	background = "#f5f5f5",
	isDark = false,
	showQR = false,
	availableVendor = false,
	marginBottom = 0,
}) => {
	const trackSocialLogoClick = async (social) => {
		const Mixpanel = await import("../../utils/Mixpanel");
		Mixpanel.default.track("Social logo click", {
			Source: source,
			page: getUrlPath(),
			Section: "Footer",
			social,
		});
	};

	const handlePlayStoreIconClick = async () => {
		import("../../utils/Mixpanel").then((Mixpanel) => {
			Mixpanel.default.track("Download app click", {
				page: getUrlPath(),
				Source: source,
				Section: "Footer",
				pageType: "download apna app",
				actionType: "play store icon",
			});
		});

		const playStoreUrl = await createBranchDeepLink({
			id: "",
			campaign: BRANCH_APP_DOWNLOAD_CAMPAIGNS.playStoreIcon,
			pageType: source,
			utm_source: "Apna Main Website",
			utm_campaign: "Download apna app page",
			utm_medium: "button",
			...getTrackingParams(null, true),
		});

		window.open(playStoreUrl, "_blank");
	};

	const vendor = availableVendor || isHostLaunchedMicrosite();

	return (
		<div
			style={{
				background: isDark ? "#190A28" : background,
				marginBottom: `${marginBottom || 0}px`,
			}}
		>
			<SocialContainerWrapper
				className={clsx(isDark ? "!bg-[#190A28]" : "", "mx-auto max-w-screen-xl")}
				background={background}
			>
				<LeftSection>
					<LeftSectionContent>
						{vendor ? (
							<ApnaViLogoContainer>
								<ApnaViLogo />
							</ApnaViLogoContainer>
						) : (
							<LogoContainer>
								<ApnaTimeLogo />
							</LogoContainer>
						)}
						<SocialMediaContainer>
							<FollowUsText className={isDark ? "!text-white" : ""}>
								Follow us on social media
							</FollowUsText>
							<SocialMediaLogosWrapper>
								<a
									href="https://www.facebook.com/APNA-2386268451700180"
									target="_blank"
									id="social-footer-fb-link"
									rel="noopener noreferrer"
									aria-label="Facebook"
									onClick={() => {
										trackSocialLogoClick("Facebook");
									}}
								>
									{isDark ? (
										<svg
											width="24"
											height="25"
											viewBox="0 0 24 25"
											fill="none"
											xmlns="http://www.w3.org/2000/svg"
										>
											<path
												d="M24.0001 12.5735C24.0001 5.90454 18.6271 0.498535 12.0001 0.498535C5.37007 0.500035 -0.00292969 5.90454 -0.00292969 12.575C-0.00292969 18.6005 4.38607 23.5955 10.1221 24.5015V16.064H7.07707V12.575H10.1251V9.91253C10.1251 6.88704 11.9176 5.21603 14.6581 5.21603C15.9721 5.21603 17.3446 5.45154 17.3446 5.45154V8.42154H15.8311C14.3416 8.42154 13.8766 9.35303 13.8766 10.3085V12.5735H17.2036L16.6726 16.0625H13.8751V24.5C19.6111 23.594 24.0001 18.599 24.0001 12.5735Z"
												fill="white"
											/>
										</svg>
									) : (
										<FacebookLogo />
									)}
								</a>
								<a
									href="https://www.linkedin.com/company/26594389/admin/"
									target="_blank"
									id="social-footer-linkedin-link"
									rel="noopener noreferrer"
									onClick={() => {
										trackSocialLogoClick("LinkedIn");
									}}
									aria-label="LinkedIn"
								>
									{isDark ? (
										<svg
											width="23"
											height="23"
											viewBox="0 0 23 23"
											fill="none"
											xmlns="http://www.w3.org/2000/svg"
										>
											<path
												fillRule="evenodd"
												clipRule="evenodd"
												d="M0.75 2.338C0.75 1.85053 0.943646 1.38303 1.28834 1.03834C1.63303 0.693648 2.10053 0.500002 2.588 0.500002H20.91C21.1516 0.499608 21.3909 0.546865 21.6141 0.639069C21.8374 0.731273 22.0403 0.866612 22.2112 1.03734C22.3822 1.20807 22.5177 1.41083 22.6102 1.63401C22.7026 1.8572 22.7501 2.09643 22.75 2.338V20.66C22.7503 20.9016 22.7029 21.1409 22.6106 21.3642C22.5183 21.5875 22.3828 21.7904 22.212 21.9613C22.0412 22.1322 21.8384 22.2678 21.6151 22.3602C21.3919 22.4526 21.1526 22.5001 20.911 22.5H2.588C2.34655 22.5 2.10746 22.4524 1.8844 22.36C1.66134 22.2676 1.45867 22.1321 1.28798 21.9613C1.1173 21.7905 0.981932 21.5878 0.889623 21.3647C0.797313 21.1416 0.749869 20.9025 0.75 20.661V2.338ZM9.458 8.888H12.437V10.384C12.867 9.524 13.967 8.75 15.62 8.75C18.789 8.75 19.54 10.463 19.54 13.606V19.428H16.333V14.322C16.333 12.532 15.903 11.522 14.811 11.522C13.296 11.522 12.666 12.611 12.666 14.322V19.428H9.458V8.888ZM3.958 19.291H7.166V8.75H3.958V19.29V19.291ZM7.625 5.312C7.63105 5.58668 7.58217 5.85979 7.48124 6.11532C7.38031 6.37084 7.22935 6.60364 7.03723 6.80003C6.84511 6.99643 6.6157 7.15248 6.36246 7.25901C6.10921 7.36554 5.83724 7.42042 5.5625 7.42042C5.28776 7.42042 5.01579 7.36554 4.76255 7.25901C4.5093 7.15248 4.27989 6.99643 4.08777 6.80003C3.89565 6.60364 3.74469 6.37084 3.64376 6.11532C3.54283 5.85979 3.49395 5.58668 3.5 5.312C3.51187 4.77286 3.73439 4.25979 4.11989 3.88269C4.50539 3.50558 5.02322 3.29442 5.5625 3.29442C6.10178 3.29442 6.61961 3.50558 7.00512 3.88269C7.39062 4.25979 7.61313 4.77286 7.625 5.312Z"
												fill="white"
											/>
										</svg>
									) : (
										<LinkedinLogo />
									)}
								</a>
								<a
									href="https://twitter.com/apnahq"
									target="_blank"
									id="social-footer-twitter-link"
									rel="noopener noreferrer"
									onClick={() => {
										trackSocialLogoClick("Twitter");
									}}
									aria-label="Twitter"
								>
									{isDark ? (
										<svg
											width="24"
											height="19"
											viewBox="0 0 24 19"
											fill="none"
											xmlns="http://www.w3.org/2000/svg"
										>
											<path
												d="M23.1425 2.43708C22.3075 2.80708 21.4105 3.05708 20.4675 3.17008C21.4405 2.58787 22.1685 1.67154 22.5155 0.592077C21.6014 1.13507 20.6009 1.51727 19.5575 1.72208C18.8559 0.972942 17.9266 0.476403 16.9138 0.309551C15.9011 0.142699 14.8616 0.314868 13.9568 0.79933C13.0519 1.28379 12.3323 2.05344 11.9097 2.98878C11.4871 3.92412 11.3851 4.97283 11.6195 5.97208C9.76721 5.87907 7.95515 5.39763 6.30095 4.55898C4.64674 3.72034 3.18736 2.54324 2.01752 1.10408C1.61752 1.79408 1.38752 2.59408 1.38752 3.44608C1.38708 4.21307 1.57596 4.96832 1.9374 5.64481C2.29885 6.3213 2.82168 6.89812 3.45952 7.32408C2.7198 7.30054 1.9964 7.10066 1.34952 6.74108V6.80108C1.34945 7.87682 1.72156 8.91945 2.40271 9.75207C3.08386 10.5847 4.03209 11.156 5.08652 11.3691C4.40031 11.5548 3.68086 11.5821 2.98252 11.4491C3.28002 12.3747 3.85952 13.1841 4.63989 13.764C5.42026 14.3439 6.36244 14.6653 7.33452 14.6831C5.68436 15.9785 3.64641 16.6812 1.54852 16.6781C1.1769 16.6782 0.8056 16.6565 0.436523 16.6131C2.566 17.9823 5.04486 18.7089 7.57652 18.7061C16.1465 18.7061 20.8315 11.6081 20.8315 5.45208C20.8315 5.25208 20.8265 5.05008 20.8175 4.85008C21.7288 4.19105 22.5154 3.37497 23.1405 2.44008L23.1425 2.43708Z"
												fill="white"
											/>
										</svg>
									) : (
										<TwitterLogo />
									)}
								</a>
								<a
									href="https://www.instagram.com/apnahq/"
									target="_blank"
									id="social-footer-instagram-link"
									rel="noopener noreferrer"
									onClick={() => {
										trackSocialLogoClick("Instagram");
									}}
									aria-label="Instagram"
								>
									{isDark ? (
										<svg
											width="23"
											height="23"
											viewBox="0 0 23 23"
											fill="none"
											xmlns="http://www.w3.org/2000/svg"
										>
											<path
												fillRule="evenodd"
												clipRule="evenodd"
												d="M6.715 0.566C7.888 0.512 8.262 0.5 11.25 0.5C14.238 0.5 14.612 0.513 15.784 0.566C16.956 0.619 17.756 0.806 18.456 1.077C19.189 1.354 19.854 1.787 20.404 2.347C20.964 2.896 21.396 3.56 21.672 4.294C21.944 4.994 22.13 5.794 22.184 6.964C22.238 8.139 22.25 8.513 22.25 11.5C22.25 14.488 22.237 14.862 22.184 16.035C22.131 17.205 21.944 18.005 21.672 18.705C21.396 19.4391 20.9633 20.1042 20.404 20.654C19.854 21.214 19.189 21.646 18.456 21.922C17.756 22.194 16.956 22.38 15.786 22.434C14.612 22.488 14.238 22.5 11.25 22.5C8.262 22.5 7.888 22.487 6.715 22.434C5.545 22.381 4.745 22.194 4.045 21.922C3.31092 21.646 2.64582 21.2133 2.096 20.654C1.53638 20.1047 1.10331 19.4399 0.827 18.706C0.556 18.006 0.37 17.206 0.316 16.036C0.262 14.861 0.25 14.487 0.25 11.5C0.25 8.512 0.263 8.138 0.316 6.966C0.369 5.794 0.556 4.994 0.827 4.294C1.10372 3.56008 1.53712 2.89531 2.097 2.346C2.64604 1.7865 3.31047 1.35344 4.044 1.077C4.744 0.806 5.544 0.62 6.714 0.566H6.715ZM15.695 2.546C14.535 2.493 14.187 2.482 11.25 2.482C8.313 2.482 7.965 2.493 6.805 2.546C5.732 2.595 5.15 2.774 4.762 2.925C4.249 3.125 3.882 3.362 3.497 3.747C3.13205 4.10205 2.85118 4.53428 2.675 5.012C2.524 5.4 2.345 5.982 2.296 7.055C2.243 8.215 2.232 8.563 2.232 11.5C2.232 14.437 2.243 14.785 2.296 15.945C2.345 17.018 2.524 17.6 2.675 17.988C2.851 18.465 3.132 18.898 3.497 19.253C3.852 19.618 4.285 19.899 4.762 20.075C5.15 20.226 5.732 20.405 6.805 20.454C7.965 20.507 8.312 20.518 11.25 20.518C14.188 20.518 14.535 20.507 15.695 20.454C16.768 20.405 17.35 20.226 17.738 20.075C18.251 19.875 18.618 19.638 19.003 19.253C19.368 18.898 19.649 18.465 19.825 17.988C19.976 17.6 20.155 17.018 20.204 15.945C20.257 14.785 20.268 14.437 20.268 11.5C20.268 8.563 20.257 8.215 20.204 7.055C20.155 5.982 19.976 5.4 19.825 5.012C19.625 4.499 19.388 4.132 19.003 3.747C18.6479 3.38207 18.2157 3.10121 17.738 2.925C17.35 2.774 16.768 2.595 15.695 2.546ZM9.845 14.891C10.6297 15.2176 11.5034 15.2617 12.3169 15.0157C13.1305 14.7697 13.8334 14.2489 14.3056 13.5422C14.7778 12.8356 14.9901 11.9869 14.906 11.1411C14.822 10.2953 14.447 9.50497 13.845 8.905C13.4612 8.52148 12.9972 8.22781 12.4863 8.04515C11.9755 7.86248 11.4304 7.79536 10.8905 7.84862C10.3506 7.90187 9.82915 8.07418 9.3638 8.35313C8.89845 8.63208 8.50074 9.01074 8.1993 9.46185C7.89786 9.91296 7.70019 10.4253 7.62052 10.962C7.54084 11.4986 7.58115 12.0463 7.73854 12.5655C7.89593 13.0847 8.16648 13.5626 8.53072 13.9647C8.89496 14.3668 9.34382 14.6832 9.845 14.891ZM7.252 7.502C7.77702 6.97697 8.40032 6.5605 9.0863 6.27636C9.77228 5.99222 10.5075 5.84597 11.25 5.84597C11.9925 5.84597 12.7277 5.99222 13.4137 6.27636C14.0997 6.5605 14.723 6.97697 15.248 7.502C15.773 8.02702 16.1895 8.65032 16.4736 9.3363C16.7578 10.0223 16.904 10.7575 16.904 11.5C16.904 12.2425 16.7578 12.9777 16.4736 13.6637C16.1895 14.3497 15.773 14.973 15.248 15.498C14.1877 16.5583 12.7495 17.154 11.25 17.154C9.75046 17.154 8.31234 16.5583 7.252 15.498C6.19166 14.4377 5.59597 12.9995 5.59597 11.5C5.59597 10.0005 6.19166 8.56234 7.252 7.502ZM18.158 6.688C18.2881 6.56527 18.3923 6.41768 18.4643 6.25397C18.5363 6.09027 18.5748 5.91377 18.5774 5.73493C18.58 5.55609 18.5467 5.37855 18.4795 5.21281C18.4122 5.04707 18.3124 4.89651 18.186 4.77004C18.0595 4.64357 17.9089 4.54376 17.7432 4.47652C17.5775 4.40928 17.3999 4.37598 17.2211 4.37858C17.0422 4.38119 16.8657 4.41965 16.702 4.4917C16.5383 4.56374 16.3907 4.6679 16.268 4.798C16.0293 5.05103 15.8986 5.38712 15.9037 5.73493C15.9088 6.08274 16.0492 6.41488 16.2952 6.66084C16.5411 6.90681 16.8733 7.04723 17.2211 7.0523C17.5689 7.05737 17.905 6.92669 18.158 6.688Z"
												fill="white"
											/>
										</svg>
									) : (
										<InstagramLogo />
									)}
								</a>
								<a
									href="https://www.youtube.com/channel/UCl-retoBiPxEqXMxxIhBt7A"
									target="_blank"
									id="social-footer-youtube-link"
									rel="noopener noreferrer"
									onClick={() => {
										trackSocialLogoClick("Youtube");
									}}
									aria-label="Youtube"
								>
									{isDark ? (
										<svg
											width="21"
											height="15"
											viewBox="0 0 21 15"
											fill="none"
											xmlns="http://www.w3.org/2000/svg"
										>
											<path
												d="M20.5933 2.70301C20.4794 2.28041 20.2568 1.89501 19.9477 1.58518C19.6386 1.27534 19.2537 1.05187 18.8313 0.937007C17.2653 0.507007 11.0003 0.500008 11.0003 0.500008C11.0003 0.500008 4.73633 0.493007 3.16933 0.904007C2.74725 1.02415 2.36315 1.25078 2.0539 1.56214C1.74464 1.8735 1.52062 2.25913 1.40333 2.68201C0.99033 4.24801 0.98633 7.49601 0.98633 7.49601C0.98633 7.49601 0.98233 10.76 1.39233 12.31C1.62233 13.167 2.29733 13.844 3.15533 14.075C4.73733 14.505 10.9853 14.512 10.9853 14.512C10.9853 14.512 17.2503 14.519 18.8163 14.109C19.2388 13.9943 19.6241 13.7714 19.934 13.4622C20.2439 13.153 20.4677 12.7682 20.5833 12.346C20.9973 10.781 21.0003 7.53401 21.0003 7.53401C21.0003 7.53401 21.0203 4.26901 20.5933 2.70301ZM8.99633 10.505L9.00133 4.50501L14.2083 7.51001L8.99633 10.505Z"
												fill="white"
											/>
										</svg>
									) : (
										<YoutubeLogo />
									)}
								</a>
							</SocialMediaLogosWrapper>
						</SocialMediaContainer>
					</LeftSectionContent>
					<Hr />
					<CopyrightText
						className={clsx(
							"!mt-6 flex w-full max-w-[494px] flex-col justify-between gap-y-4 md:flex-row md:pr-4",
							isDark && "!text-white"
						)}
					>
						© {new Date().getFullYear()} Apna | All rights reserved{" "}
						<Link href="/privacy">Privacy Policy</Link>{" "}
						<Link
							href={
								typeof window !== "undefined" &&
								window.location.href.includes("apna-advantage")
									? "/advantage-terms-and-conditions"
									: "/user-agreement"
							}
						>
							Apna Advantage T&C
						</Link>
						<Link href="/rewards-user-agreement"> Rewards T&C</Link>
					</CopyrightText>
				</LeftSection>
				<RightSection>
					{showQR ? (
						<div className="hidden items-center rounded-2xl bg-white p-6 md:flex">
							<div className="">
								<p className="m-0 text-[20px] font-bold">
									Apply on the go
								</p>
								<p className="m-0 mt-1 text-md">
									Get real time job updates on our App
								</p>

								<button
									onClick={handlePlayStoreIconClick}
									type="button"
									aria-label="Play Store image"
								>
									<img
										className="-ml-2"
										width={150}
										src="https://play.google.com/intl/en_us/badges/static/images/badges/en_badge_web_generic.png"
										alt="Get it on google play"
										id="playstore-icon"
									/>
								</button>
							</div>
							<img
								className="h-[120px] w-[120px] rounded-2xl border bg-white object-contain p-2"
								src="https://storage.googleapis.com/mumbai_apnatime_prod/apna-home/app-qr.png"
								alt="Scan to download"
							/>
						</div>
					) : (
						<ImageContainer>
							<PeopleImage
								src="/cloudinary/footer-image-a92468231747f8b656434a809fd78f4c_qprysl.png"
								alt="Apna Circle"
								layout="fill"
								showbackup={false}
							/>
						</ImageContainer>
					)}
				</RightSection>
			</SocialContainerWrapper>
		</div>
	);
};

const SocialMediaContainer = styled.div``;

const SocialContainerWrapper = styled.div<SocialContainerWrapperProps>`
	display: flex;
	justify-content: center;
	align-items: center;
	padding: 28px 16px 0;
	background-color: ${(props) => props.background};

	${bp.md} {
		padding: 38px 80px 0;
	}

	${bp.lg} {
		justify-content: space-between;
		padding: 64px 16px 64px 16px;
	}
`;

const LogoContainer = styled.div`
	width: 64px;
	height: 64px;
	margin-right: 16px;
	border-right: 1px solid #8c8594;
	& svg {
		width: 64px;
		height: 64px;
		margin: 0 -16px;
	}

	${bp.md} {
		width: 84px;
		height: 84px;
		margin-right: 20px;
		border-right: none;
		& svg {
			width: 84px;
			height: 84px;
		}
	}
`;

const ApnaViLogoContainer = styled.div`
	margin-top: 15px;
`;

const LeftSection = styled.div`
	width: 100%;

	${bp.md} {
		width: 492px;
	}
`;

const RightSection = styled.div`
	align-self: flex-end;
	#playstore-icon {
		cursor: pointer;
	}
`;

const LeftSectionContent = styled.div`
	display: flex;
	justify-content: center;
	align-items: center;

	${bp.lg} {
		justify-content: flex-start;
	}
`;

const FollowUsText = styled.p`
	color: #4d3951;
	font-weight: 600;
	font-size: 18px;
	line-height: 22px;
	margin: 6px 0 20px;

	${bp.md} {
		font-size: 20px;
		line-height: 24px;
	}
`;

const SocialMediaLogosWrapper = styled.div`
	display: flex;
	align-items: center;
	justify-content: flex-start;

	& a:not(:first-child) {
		margin-left: 18px;
	}

	${bp.lg} {
		margin-left: 0;
	}
`;

const Hr = styled.hr`
	background-color: rgba(216, 216, 216, 0.5);
	margin-top: 22px;
	margin-bottom: 0;
`;

const CopyrightText = styled.div`
	font-size: 12px;
	line-height: 16px;
	color: #a5a5a5;
	margin: 8px auto 18px;
	text-align: center;

	${bp.lg} {
		margin: 12px 0 0;
		text-align: left;
	}
`;

const ImageContainer = styled.div`
	display: none;
	position: relative;

	${bp.lg} {
		display: block;
		width: 339px;
		height: 176px;
	}
`;

const PeopleImage = styled(CustomImage)`
	display: none;
	object-fit: cover;

	${bp.lg} {
		display: block;
	}
`;

export default FooterSocialContainer;
